import React from 'react';
import { Card, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

export default function ConfirmationView({ onNominateAnother }) {
  return (
    <Card className="text-center shadow-sm p-4 mx-auto" style={{ maxWidth: 540 }}>
      <div className="mb-3" style={{ fontSize: '3rem' }}>🎉</div>
      <h5 className="mb-3">Nomination Submitted</h5>
      <p className="text-muted mb-4">
        Thank you for making the time to nominate one of your colleagues for an employee
        recognition. If they are successful, both you and they will be notified by a member
        of the HR team.
      </p>
      <Button variant="primary" onClick={onNominateAnother}>
        Nominate Someone Else
      </Button>
    </Card>
  );
}

ConfirmationView.propTypes = {
  onNominateAnother: PropTypes.func.isRequired
};
